import React, { useState } from 'react';
import { Row, Col, Tabs } from 'antd';
import { BadgeDollarSign, ShoppingBag, Dumbbell } from 'lucide-react';
import dayjs from 'dayjs';
import DatePicker from 'components/date-picker';
import { DATE_FORMAT } from 'constants/app-constants';
import OutstandingListFunctional from './outstanding-list-functional';
import { useI18n } from 'hooks/useI18n';

const OutstandingTab = () => {
	const [month, setMonth] = useState(dayjs()); // Default to current month
	const { t } = useI18n();

	const onMonthChange = (selectedMonth) => {
		setMonth(selectedMonth || null);
	};

	const tabItems = [
		{
			key: 'membership',
			label: (
				<span>
					<BadgeDollarSign size={16} style={{ marginRight: 6 }} />
					{t('outstanding.tabs.memberships')}
				</span>
			),
			children: <OutstandingListFunctional reportType="membership" month={month} />,
		},
		{
			key: 'product',
			label: (
				<span>
					<ShoppingBag size={16} style={{ marginRight: 6 }} />
					{t('outstanding.tabs.products')}
				</span>
			),
			children: <OutstandingListFunctional reportType="product" month={month} />,
		},
		{
			key: 'personalTraining',
			label: (
				<span>
					<Dumbbell size={16} style={{ marginRight: 6 }} />
					{t('outstanding.tabs.personal_training')}
				</span>
			),
			children: <OutstandingListFunctional reportType="personalTraining" month={month} />,
		},
	];

	return (
		<Row className="payments-tab-container" style={{ height: '80%' }}>
			<Col xl={24} className="container">
				<Row style={{ paddingTop: 20, marginBottom: 16 }}>
					<Col xl={21} md={20}>
						<span style={{ marginRight: 8 }}>{t('outstanding.select_month')}:</span>
						<DatePicker
							allowClear
							style={{ width: 150 }}
							picker="month"
							value={month}
							format={DATE_FORMAT.MMM_YYYY}
							onChange={onMonthChange}
							placeholder={t('outstanding.placeholders.all_months')}
						/>
					</Col>
				</Row>

				<Tabs defaultActiveKey="membership" destroyInactiveTabPane items={tabItems} />
			</Col>
		</Row>
	);
};

export default OutstandingTab;
